import { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Box } from '@mui/system';
import { Alert } from '@mui/material';
import PaginationControlled from './PaginationControlled';
import CSVReport from './CSVReport';




export default function FullText({data}) {

    const [textQueryInput, setTextQueryInput] = useState('');
    const [textQueryResult, setTextQueryResult] = useState([]);
    const [message, setMessage] = useState(''); 
    const [transcription, setTranscription] = useState('dip');
    
    const handleChangeTranscription = (event) => {setTranscription(event.target.value)};
    function handleChange(e) {setTextQueryInput(e.target.value)}
 
    function handleSubmit(e) {
      e.preventDefault()
      let answer = []
      for (const text of data) {

        let token_index =  2
        const text_name = text['text']


        if (transcription === 'cyr') {
          token_index = 1
        } else if (transcription === 'lat') {
          token_index = 0
        }


        for (const [, sentence] of Object.entries(text['sentences'])) {
          
          let lemmata  = [];
          let annotations = [];
          let tokens = [];
          let UDs = [];
          let sent_plain = '';
          let translation = '';
          let annotationsExt = [];
          let UDsOfParents = [];
          let sentID = null;

            for (const word of sentence) {

                sentID = word[6]
              sent_plain += word[token_index];
              sent_plain += ' ' ;
              tokens.push(word[token_index]);
              lemmata.push(word[3]);
              annotations.push(word[4]);
              UDs.push(word[9]);

              UDsOfParents.push(word[8]);
              word[5] ? annotationsExt.push(word[5]) : annotationsExt.push('_');



              if (word[13]) {
                translation += word[13]
                translation += ' / '
              }
              
              
            }

            if (sent_plain.includes(textQueryInput)) {
              answer.push([sent_plain, text_name, tokens, lemmata, annotations, translation.slice(0, -2), UDs, 0, annotationsExt, UDsOfParents, sentID ])
              
            
            }

        }
        
  
      }
      setTextQueryInput(textQueryInput)
      setMessage(`Your query has given ${answer.length} results.`)
      setTextQueryResult(answer)
    }


    return (
      <>
      <Box>
      <form  onSubmit = {handleSubmit}>

<Grid container spacing={2} direction='column' >
           <Grid item xs={12} sm={6}>
         <input   type='text'   placeholder="*Enter your query here" onChange={handleChange} style={{
             width: "300px",
             height: "27px"
         }}/>
         </Grid>

         <Grid item xs={12} sm={6}>

         <form >

        <select
          value={transcription}
          onChange={handleChangeTranscription}
        >
          <option value={'lat'}>Latin</option>
          <option value={'cyr'}>Cyrillic</option>
          <option value={'dip'}>Diplomatic</option>
        </select>
       
      </form>

           </Grid>

         <Grid item xs={12} sm={6} >  
         <button
             type='submit'  disabled={!textQueryInput}>Submit</button>
         </Grid>
      
      </Grid>
      </form>

      <Box mt={2}>
      
      {message && <Alert severity="info" style={{fontFamily: 'Arial'}} >{message}</Alert>}
     
      </Box>

      <CSVReport searchResult={textQueryResult}  domain="full" />

      <br/>


      <PaginationControlled queryResult={textQueryResult} query={textQueryInput} domain="full" trans={transcription}/>

      </Box>

      
      </>
    );
  }

// old variant:
  //  <br/>
  //  <ol> {
  //    textQueryResult.map((item, index) => ( <li style = {{ textAlign: 'left' }}
  //      key = {index}>  <HandleSentence sentence={item}/> </li>
  //     ))
  //     }
  //    </ol>
